import { render, staticRenderFns } from "./goodsElSelect.vue?vue&type=template&id=2987ec3e"
import script from "./goodsElSelect.vue?vue&type=script&lang=js"
export * from "./goodsElSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports